<template>
  <div>
    <div style="margin-bottom:10px;">
      <Input v-model="searchName" placeholder="输入用户名" style="width:200px;margin-right:10px;" />
      <Button type="primary" @click="fetchList">查询</Button>
      <Button type="primary" style="margin-left:10px;" @click="openAddModal">新增用户</Button>
    </div>

    <Table :columns="columns" :data="list" border>
    </Table>

    <div style="margin:10px 0;overflow:hidden;">
      <div style="float:right;">
        <Page :total="total" :current="current" :page-size="pageSize" @on-change="changePage" />
      </div>
    </div>

    <!-- 新增/编辑弹窗 -->
    <Modal v-model="modalVisible" :title="editMode ? '编辑用户' : '新增用户'" width="440" @on-cancel="resetForm">
      <Form :model="form" :rules="rules" ref="form" :label-width="80">
        <FormItem label="用户名" prop="yhmc">
          <Input v-model="form.yhmc" placeholder="请输入用户名" />
        </FormItem>
        <FormItem label="密码" prop="password" v-if="!editMode">
          <Input v-model="form.password" type="password" placeholder="请输入密码" />
        </FormItem>
        <FormItem label="角色" prop="menus">
          <Select v-model="form.menus" placeholder="请选择角色">
            <Option v-for="r in roleList" :key="r.role_key" :value="r.role_key">{{ r.role_name }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="resetForm">取消</Button>
        <Button type="primary" @click="submitForm">确认</Button>
      </div>
    </Modal>

    <!-- 重置密码弹窗 -->
    <Modal v-model="pwdModalVisible" title="重置密码" width="380">
      <Form :label-width="80">
        <FormItem label="新密码">
          <Input v-model="newPwd" type="password" placeholder="请输入新密码" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="pwdModalVisible=false">取消</Button>
        <Button type="primary" @click="submitResetPwd">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getSysUserList, addSysUser, updateSysUser, deleteSysUser, resetSysUserPwd } from '@/api/sysmanage';
import { getRoleList } from '@/api/sysmanage';

export default {
  data() {
    return {
      searchName: '',
      list: [],
      total: 0,
      current: 1,
      pageSize: 20,
      roleList: [],
      modalVisible: false,
      editMode: false,
      pwdModalVisible: false,
      newPwd: '',
      resetUserId: null,
      form: { id: null, yhmc: '', password: '', menus: '' },
      rules: {
        yhmc: [{ required: true, message: '用户名不能为空', trigger: 'blur' }],
        password: [{ required: true, message: '密码不能为空', trigger: 'blur' }],
        menus: [{ required: true, message: '请选择角色', trigger: 'change' }],
      },
      columns: [
        { title: 'ID', key: 'id', width: 70 },
        { title: '用户名', key: 'yhmc' },
        { title: '角色', key: 'menus' },
        {
          title: '操作', key: 'action', width: 240, align: 'center',
          render: (h, params) => h('div', [
            h('Button', { props: { type: 'primary', size: 'small' }, style: { marginRight: '6px' }, on: { click: () => this.openEditModal(params.row) } }, '编辑'),
            h('Button', { props: { type: 'warning', size: 'small' }, style: { marginRight: '6px' }, on: { click: () => this.openPwdModal(params.row) } }, '重置密码'),
            h('Button', { props: { type: 'error', size: 'small' }, on: { click: () => this.handleDelete(params.row) } }, '删除'),
          ])
        }
      ]
    };
  },
  mounted() {
    this.fetchList();
    this.fetchRoles();
  },
  methods: {
    fetchList() {
      getSysUserList({ yhmc: this.searchName || undefined, page: this.current, pageSize: this.pageSize })
        .then(res => {
          this.list = res.data.rows || res.data;
          this.total = res.data.total || res.data.length || 0;
        }).catch(() => {});
    },
    fetchRoles() {
      getRoleList({}).then(res => {
        this.roleList = res.data || [];
      }).catch(() => {});
    },
    changePage(p) { this.current = p; this.fetchList(); },
    openAddModal() {
      this.editMode = false;
      this.form = { id: null, yhmc: '', password: '', menus: '' };
      this.modalVisible = true;
    },
    openEditModal(row) {
      this.editMode = true;
      this.form = { id: row.id, yhmc: row.yhmc, password: '', menus: row.menus };
      this.modalVisible = true;
    },
    openPwdModal(row) {
      this.resetUserId = row.id;
      this.newPwd = '';
      this.pwdModalVisible = true;
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const api = this.editMode ? updateSysUser : addSysUser;
        api(this.form).then(() => {
          this.$Message.success(this.editMode ? '编辑成功' : '新增成功');
          this.modalVisible = false;
          this.fetchList();
        }).catch(() => {});
      });
    },
    submitResetPwd() {
      if (!this.newPwd) { this.$Message.error('密码不能为空'); return; }
      resetSysUserPwd({ id: this.resetUserId, password: this.newPwd }).then(() => {
        this.$Message.success('重置成功');
        this.pwdModalVisible = false;
      }).catch(() => {});
    },
    handleDelete(row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定删除用户【${row.yhmc}】？`,
        onOk: () => {
          deleteSysUser({ id: row.id }).then(() => {
            this.$Message.success('删除成功');
            this.fetchList();
          }).catch(() => {});
        }
      });
    },
    resetForm() { this.modalVisible = false; this.$refs.form && this.$refs.form.resetFields(); }
  }
};
</script>
